export default __webpack_public_path__ + "static/media/loginNoBg.6eb14b40.png";